import { render } from "./FoxForesightSettings.vue?vue&type=template&id=0514ff80"
import script from "./FoxForesightSettings.vue?vue&type=script&lang=js"
export * from "./FoxForesightSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__